const DEFAULT_VALUE_FORMATTING_ERROR = 'Value cannot be formatted.';

export default class ValueFormattingError extends Error {
  constructor(message: string = DEFAULT_VALUE_FORMATTING_ERROR) {
    super(message);
  }
}
